import {PasswordReminderForm} from 'components/template/PasswordReminderForm'

export const PasswordReminder = () => {
  return (
    <div className="text-gray-800 flex flex-col justify-center items-center">
      <PasswordReminderForm />
    </div>
  )
}
